(function () {
    // Optimization for Repeat Views
    if (sessionStorage.fontsLoadedCriticalFoftPreloadPolyfill) {
        document.documentElement.className += " fonts-loaded";
    } else {
        var fontInitial = new FontFaceObserver('Mont', {
            weight: 400
        });

        Promise.all([fontInitial.load(null, 5000)]).then(function () {
            document.documentElement.className += " fonts-loaded";
            sessionStorage.fontsLoadedCriticalFoftPreloadPolyfill = true;
        });
    }
})();